import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const MedicationEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.medication),
        medicine: Type.Optional(Type.String()),
        amount: Type.Optional(Type.String()),
        measure: Type.Optional(Type.String())
    })
]));
